function parseNumber(value, addCurrency = false, decimals = 2) {
  let parsedValue = isNaN(value)
    ? '0'
    : parseFloat(value).toFixed(decimals);

  return addCurrency 
    ? `$${parsedValue}`
    : parsedValue;
}

function getSpacer(size) {
  let spacer = ''

  for (let i = 0; i < size; i++) {
    spacer += ' ';
  }
  
  return spacer;
}

export async function generate (reportData) {
  console.log('GEANERATE REPORT')
  console.log(reportData)
  const jsPDF = (await import('jspdf')).jsPDF || (await import('jspdf')).default;
  const autoTable = (await import('jspdf-autotable')).default; 

  const doc = new jsPDF('p', 'pt', 'letter');
  const marginLeft = 15;
  const marginRight = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  const usablePageWidth = pageWidth - marginLeft - marginRight;

  const spacingBeforeTable = 0;
  const spacingAferTable = 15;

  let cursorY = 15;

  /**
   * Page header
   */
  const businessName = JSON.parse( localStorage.getItem( 'user' )).business;

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[businessName.toUpperCase()]],
    styles: { fontSize: 14, halign: 'right', valign: 'middle' },
    headStyles: { textColor: 0, fontStyle: 'bold', halign: 'center', cellPadding: [8, 0, 8, 0] },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 8;

  /**
   * Report title
   */
  const reportTitle =  `Formulación de internación de pacientes`; 

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[reportTitle.toUpperCase()]],
    styles: { fontSize: 11, halign: 'right', valign: 'middle'},
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'center' },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 10;

  /**
   * Header data
   */
  const headerData = [
    [
      'Paciente:', reportData.patient, 
      'Cliente:', reportData.client,
    ],
    [
      'Fecha de ingreso:', reportData.admissionDate,
      'Médico responsable:', reportData.doctor
    ]
  ];

  if (reportData.egressDate) {
    headerData[1].push('Fecha de egreso:', reportData.egressDate)
  }

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: headerData,
    styles: { fontSize: 10, fontStyle: 'bold' },
    tableLineWidth: 0,
    theme: 'plain',
    tableWidth: usablePageWidth,
    columnStyles: {
      0: { textColor: 50, halign: 'left' },
      1: { textColor: 100, halign: 'left' },
      2: { textColor: 50, halign: 'left' },
      3: { textColor: 100, halign: 'left' },
      4: { textColor: 50, halign: 'left' },
      5: { textColor: 100, halign: 'left' },
    },
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingAferTable;
    }
  });

  /**
   * Hospitalization title
   */
  const hospTitle =  `1. Hospitalización u hospedaje`; 

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[hospTitle]],
    styles: { fontSize: 10, halign: 'right', valign: 'middle' },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'left' },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 10;

  /**
   * Hospitalization data
   */
  const { hospitalized, hospitalizedSubTotal } = reportData;

  const hospData = hospitalized.status ? [
    [
      'Hospitalizado:', "Sí" , 
      getSpacer(0), getSpacer(100) 
    ],
    [
      'Tarifa diaria:', parseNumber(hospitalized.price || 0, true), 
      "Días:", hospitalized.days || 0, 
    ],
    [
      "Subtotal:", parseNumber(hospitalizedSubTotal || 0, true)
    ]
  ]:[
    [
      'Hospitalizado:', "No", 
      getSpacer(0), getSpacer(100) 
    ]];

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: hospData,
    styles: { fontSize: 10, textColor: 50, halign: 'left', },
    tableLineWidth: 0,
    theme: 'plain',
    tableWidth: usablePageWidth,
    didParseCell: function(data) {
      if (data.row.index === 0) {
        if (data.column.index === 0) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.cellWidth = 100;
        } else {
          data.cell.styles.textColor = 100;
        }
      }
      
      if (data.row.index === 1) {
        if (data.column.index === 1 || data.column.index === 3) {
          data.cell.styles.textColor = 100;
        }
      }

      if (data.row.index === 2) {
        if (data.column.index === 0) {
          data.cell.styles.fontStyle = 'bold';
        }
      } 
    },
    didDrawPage: data => {
      cursorY = data.cursor.y + 5;
    }
  });

  /**
   * Hosted data
   */
  const { hosted, hostedSubTotal} = reportData;

  const hostedData = hosted.status ? [
    [
      'Hospedado:', hosted.status ? "Sí" : "No", 
      getSpacer(0), getSpacer(100) 
    ],
    [
      'Tarifa diaria:', parseNumber(hosted.price || 0, true), 
      "Días:", hosted.days, 
    ],
    [
      "Subtotal:", parseNumber(hostedSubTotal || 0, true)
    ]
  ]: [[
      'Hospedado:', hosted.status ? "Sí" : "No", 
      getSpacer(0), getSpacer(100) 
    ]];

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: hostedData,
    styles: { fontSize: 10, textColor: 50, halign: 'left', },
    tableLineWidth: 0,
    theme: 'plain',
    tableWidth: usablePageWidth,
    didParseCell: function(data) {
      if (data.row.index === 0) {
        if (data.column.index === 0) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.cellWidth = 100;
        } else {
          data.cell.styles.textColor = 100;
        }
      }
      
      if (data.row.index === 1) {
        if (data.column.index === 1 || data.column.index === 3) {
          data.cell.styles.textColor = 100;
        }
      }

      if (data.row.index === 2) {
        if (data.column.index === 0) {
          data.cell.styles.fontStyle = 'bold';
        }
      } 
    },
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingAferTable;
    }
  });

  /**
   * Meds and others
   */
  const medsAnOthersTitle =  `2. A) Medicamentos y otros aplicados`; 

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[medsAnOthersTitle]],
    styles: { fontSize: 10, halign: 'right', valign: 'middle' },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'left' },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  const { 
    serviceToInvoice1, 
    medicationsSubTotal1, 
    medications1,
  } = reportData;

  const serviceTitle1 = medications1 && medications1.length > 0?  ['Servicio a facturar', serviceToInvoice1, getSpacer(50)] : ['Sin servicio a facturar', getSpacer(50)];

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: [serviceTitle1],
    styles: { fontSize: 10, halign: 'leaft', valign: 'middle' },
     columnStyles: {
        0: {
          textColor: 50,
          fontStyle: 'bold',
          cellWidth: 250,
        },
        1: {
          textColor: 100,
        },
      },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 10;

  

  const tableColumns = [
    { header: 'Fecha', dataKey: 'date' },
    { header: 'Detalle', dataKey: 'detail' },
    { header: 'Médico', dataKey: 'doctor' },
    { header: 'Cantidad', dataKey: 'quantity' },
    { header: 'Precio', dataKey: 'price' },
    { header: 'Total', dataKey: 'total' },
  ];

// Meds and others table
if (medications1 && medications1.length > 0) {
  const medsData = medications1.map(med => {
    const total = parseNumber(Number(med.quantity) * Number(med.price), true);
    const quantity = parseNumber(med.quantity);
    const price = parseNumber(med.price, true);

    return {
      ...med,
      quantity,
      price,
      total,
    }
  });

  const bodyRows = medsData.map(row => tableColumns.map(col => row[col.dataKey]))

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [tableColumns.map(col => col.header)],
    body: bodyRows,
    styles: { fontSize: 8, halign: 'left', valign: 'middle', cellPadding: 2, },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'left' },
    columnStyles: {
      3: {
        halign: 'right',
      },
      4: {
        halign: 'right',
      },
      5: {
        halign: 'right',
      },
    },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
    // didParseCell: function (data) {
    //   if (data.row.index === finalBodyRows.length - 1) {
    //     data.cell.styles.fontStyle = 'bold';
    //     data.cell.styles.fillColor = 255;
    //     data.cell.styles.textColor = 0;
    //   }
    // }
  });

  cursorY += 10;

  const subTotalRow =  ['Subtotal:     ' + parseNumber(medicationsSubTotal1, true)]

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: [subTotalRow],
    styles: { fontSize: 10, halign: 'right', valign: 'middle' },
     columnStyles: {
        0: {
          textColor: 50,
          fontStyle: 'bold',
        },
        1: {
          textColor: 100,
          fontStyle: 'bold',
        },
      },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });
}
  /**
   * Meds 2
   */
  const meds2Title =  `2. B) Medicamentos de farmacia y otros accesorios`; 

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[meds2Title]],
    styles: { fontSize: 10, halign: 'right', valign: 'middle' },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'left' },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  const { 
    serviceToInvoice2, 
    medicationsSubTotal2, 
    medications2,
  } = reportData;
  //console.log('reportData', reportData);
  
  const serviceTitle2 =  medications2 && medications2.length > 0 ?[  'Servicio a facturar ', serviceToInvoice2, getSpacer(50)]:
                                                                  [  'Sin servicios a facturar ', getSpacer(50)]

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: [serviceTitle2],
    styles: { fontSize: 10, halign: 'leaft', valign: 'middle' },
     columnStyles: {
        0: {
          textColor: 50,
          fontStyle: 'bold',
          cellWidth: 250,
        },
        1: {
          textColor: 100,
        },
      },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 10;

  // pharma meds

  const pharmaData = medications2.map(med => {
    const total = parseNumber(Number(med.quantity) * Number(med.price), true);
    const quantity = parseNumber(med.quantity);
    const price = parseNumber(med.price, true);

    return {
      ...med,
      quantity,
      price,
      total,
    }
  });
  
  if (pharmaData && pharmaData.length > 0) {

    const pharmaRows = pharmaData.map(row => tableColumns.map(col => row[col.dataKey]))

    autoTable(doc, {
      startY: cursorY,
      margin: { left: marginLeft, right: marginRight },
      head: [tableColumns.map(col => col.header)],
      body: pharmaRows,
      styles: { fontSize: 8, halign: 'left', valign: 'middle', cellPadding: 2, },
      headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'left' },
      columnStyles: {
        3: {
          halign: 'right',
        },
        4: {
          halign: 'right',
        },
        5: {
          halign: 'right',
        },
      },
      theme: 'plain',
      didDrawPage: data => {
        cursorY = data.cursor.y + spacingBeforeTable;
      },
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      // didParseCell: function (data) {
      //   if (data.row.index === finalBodyRows.length - 1) {
      //     data.cell.styles.fontStyle = 'bold';
      //     data.cell.styles.fillColor = 255;
      //     data.cell.styles.textColor = 0;
      //   }
      // }
    });

    cursorY += 10;

    const pharmaSubtotalRows =  ['Subtotal:     ' + parseNumber(medicationsSubTotal2, true)]

    autoTable(doc, {
      startY: cursorY,
      margin: { left: marginLeft, right: marginRight },
      body: [pharmaSubtotalRows],
      styles: { fontSize: 10, halign: 'right', valign: 'middle' },
      columnStyles: {
          0: {
            textColor: 50,
            fontStyle: 'bold',
          },
          1: {
            textColor: 100,
            fontStyle: 'bold',
          },
        },
      theme: 'plain',
      didDrawPage: data => {
        cursorY = data.cursor.y + spacingBeforeTable;
      },
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
    });
  }

  /**
   * Meds 3
   */
  const servicesTitle =  `3. Otros servicios`; 

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[servicesTitle]],
    styles: { fontSize: 10, halign: 'right', valign: 'middle' },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'left' },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  const { 
    services, 
    servicesSubTotal,
  } = reportData;

  // services 
  const servicesData = services.map(med => {
    const total = parseNumber(Number(med.quantity) * Number(med.price), true);
    const quantity = parseNumber(med.quantity);
    const price = parseNumber(med.price, true);

    return {
      ...med,
      quantity,
      price,
      total,
    }
  });
  
  const serviceTitle3 =  services && services.length > 0 ?[  'Servicios a facturar ', getSpacer(50)]:
                                                                  [  'Sin servicios a facturar ', getSpacer(50)]

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: [serviceTitle3],
    styles: { fontSize: 10, halign: 'leaft', valign: 'middle' },
     columnStyles: {
        0: {
          textColor: 50,
          fontStyle: 'bold',
          cellWidth: 250,
        },
        1: {
          textColor: 100,
        },
      },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });
  if(services && services.length > 0){
  const servicesRows = servicesData.map(row => tableColumns.map(col => row[col.dataKey]))

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [tableColumns.map(col => col.header)],
    body: servicesRows,
    styles: { fontSize: 8, halign: 'left', valign: 'middle', cellPadding: 2, },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'left' },
    columnStyles: {
      3: {
        halign: 'right',
      },
      4: {
        halign: 'right',
      },
      5: {
        halign: 'right',
      },
    },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
    // didParseCell: function (data) {
    //   if (data.row.index === finalBodyRows.length - 1) {
    //     data.cell.styles.fontStyle = 'bold';
    //     data.cell.styles.fillColor = 255;
    //     data.cell.styles.textColor = 0;
    //   }
    // }
  });

  cursorY += 10;

  const servicesSubtotalRows =  ['Subtotal:     ' + parseNumber(servicesSubTotal, true)]

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: [servicesSubtotalRows],
    styles: { fontSize: 10, halign: 'right', valign: 'middle' },
     columnStyles: {
        0: {
          textColor: 50,
          fontStyle: 'bold',
        },
        1: {
          textColor: 100,
          fontStyle: 'bold',
        },
      },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 10;
  }
  const totalRows =  ['TOTAL:     ' + parseNumber(reportData.total, true)]

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: [totalRows],
    styles: { fontSize: 12, halign: 'right', valign: 'middle' },
     columnStyles: {
        0: {
          textColor: 50,
          fontStyle: 'bold',
        },
        1: {
          textColor: 100,
          fontStyle: 'bold',
        },
      },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeTable;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  return blobUrl;
}